import { ManagedApplication } from '@rocksoft/mdm-sdk-v2';

import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export function selectManagedApplicationId(managedApplication: ManagedApplication) {
  return createManagedApplicationId(managedApplication.udid, managedApplication.identifier);
}

export function createManagedApplicationId(udid: string, identifier: string) {
  return `${udid}-${identifier}`;
}

export const adapter: EntityAdapter<ManagedApplication> = createEntityAdapter<ManagedApplication>({
  selectId: selectManagedApplicationId,
});

export type ManagedApplicationsState = EntityState<ManagedApplication>;

export const initialState: ManagedApplicationsState = adapter.getInitialState();
